import { useEffect, useRef, useState } from 'react';
import { useClienteContext } from '../../../../contexts/ClienteContext';
import { useEmpresaContext } from '../../../../contexts/EmpresaContext';
import axiosAuth from '../../../../services/axiosAuth';
import { toast } from 'react-toastify';
import FiltroFechas from '../../FiltroFechas/FiltroFechas';
import DetalleRemito from '../../DetalleRemito/DetalleRemito';
import { generarPdfRemitos } from '../../../../services/generarPdfRemitosFiltrados';
import imagenfondo from '../../../../images/logo-sur.jpg';
import imagenFondoIntegral from '../../../../images/logo-nuevo-srl.jpg';
import { ChevronUp, ChevronDown, BookOpen, Image, Plus, Trash2, AlertCircle, Loader2, X, Upload } from 'lucide-react';

const COLUMNAS_BASE = [
    { label: 'Fecha', title: '' },
    { label: 'Admin', title: '' },
    { label: 'N° Comprobante', title: '' },
    { label: 'T.M', title: 'Tipo Movimiento' },
    { label: 'Dep', title: 'Depósito' },
    { label: 'Comentario', title: '' },
    { label: 'Estado', title: '' },
    { label: 'Propiedad', title: '' },
    { label: 'V.A', title: 'Venta Anticipada' },
    { label: 'M.S', title: 'Mueve Stock' },
    { label: 'G.F', title: 'Genera Factura' },
    { label: '', title: 'Detalle' },
    { label: '', title: '' },
];

const propiedadLabel = (p) => ({ '1': 'PROPIO', '2': 'VTA.DIRECTA', '3': 'SIEMBRA', '4': 'CTA. Y ORDEN', '5': 'PRESTAMOS', '6': 'CONSIGNADOS' }[p] || '');

const estadoClass = (rem) => rem?.Detalles[0]?.Gfaidfactura == '0' && rem?.Genfactura != '0' ? 'text-blue-600' : rem?.Genfactura == '0' ? 'text-red-600' : 'text-green-600';
const estadoText = (rem) => rem?.Detalles[0]?.Gfaidfactura == '0' && rem?.Genfactura != '0' ? 'PENDIENTE DE FACTURA' : rem?.Detalles[0]?.Talonario && rem?.Detalles[0]?.Nrocomprobante ? 'FAC N°: ' + rem?.Detalles[0]?.Talonario + '-' + rem?.Detalles[0]?.Nrocomprobante : rem?.Genfactura == '0' ? 'NO GENERA FACTURA' : 'FALTA TALONARIO Y COMPROBANTE';

// ─── MODAL CARGAR ARCHIVO ───────────────────────────────────────────────────
function ModalCargarArchivo({ clave, onClose, onCargado }) {
    const sucursal = localStorage.getItem('sucursal');
    const [selectedFile, setSelectedFile] = useState(null);
    const [cargando, setCargando] = useState(false);

    const convertFileToBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!selectedFile) { toast.error('Seleccione un archivo.', { position: 'top-center', autoClose: 3000 }); return; }
        setCargando(true);
        try {
            const base64 = await convertFileToBase64(selectedFile);
            const response = await axiosAuth.post(`/archivoremito/${sucursal}`, { claveRemito: clave, archivo: base64 });
            if (response.status === 201) {
                toast.success('Archivo subido con éxito.', { position: 'top-center', autoClose: 3000 });
                onClose();
                onCargado();
            }
        } catch (error) {
            toast.error(error.response?.status === 409 ? 'El remito ya contiene un archivo adjunto.' : 'Error al subir el archivo.', { position: 'top-center', autoClose: 3000 });
        } finally {
            setCargando(false);
        }
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black/70 z-50" onClick={onClose}>
            <div className="bg-gray-900 border border-white/10 rounded-2xl p-6 w-full max-w-sm mx-4 shadow-2xl" onClick={e => e.stopPropagation()}>
                <div className="flex items-center justify-between mb-6">
                    <h2 className="text-white font-black text-sm uppercase tracking-widest">Cargar archivo</h2>
                    <button onClick={onClose} className="text-white/30 hover:text-white transition-colors"><X size={16} /></button>
                </div>
                <form onSubmit={handleSubmit} className="space-y-5">
                    <div className="border-2 border-dashed border-white/10 hover:border-[#c9a84c]/30 rounded-xl p-6 text-center transition-all cursor-pointer"
                        onClick={() => document.getElementById('fileUpload').click()}>
                        <Upload size={24} className="text-white/20 mx-auto mb-3" />
                        <p className="text-white/30 text-xs uppercase tracking-widest">
                            {selectedFile ? selectedFile.name : 'PDF o Imagen'}
                        </p>
                        <input type="file" id="fileUpload" accept="image/*,.pdf" onChange={e => setSelectedFile(e.target.files[0])} className="hidden" />
                    </div>
                    <div className="flex gap-3">
                        <button type="button" onClick={onClose}
                            className="flex-1 py-3 border border-white/10 hover:border-white/20 text-white/40 hover:text-white text-xs font-black uppercase tracking-widest rounded-xl transition-all">
                            Cancelar
                        </button>
                        <button type="submit" disabled={cargando}
                            className="flex-1 py-3 bg-[#c9a84c] hover:bg-[#ddb94e] text-[#050f08] text-xs font-black uppercase tracking-widest rounded-xl transition-all disabled:opacity-50 flex items-center justify-center gap-2">
                            {cargando ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />}
                            {cargando ? 'Subiendo...' : 'Subir'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

// ─── MODAL ELIMINAR ARCHIVO ─────────────────────────────────────────────────
function ModalEliminarArchivo({ idArchivo, onClose, onEliminado }) {
    const sucursal = localStorage.getItem('sucursal');
    const [cargando, setCargando] = useState(false);

    const handleEliminar = async () => {
        setCargando(true);
        try {
            const response = await axiosAuth.delete(`/archivoremito/${sucursal}/${idArchivo}`);
            if (response.status === 200) {
                toast.success('Archivo eliminado correctamente.', { position: 'top-center', autoClose: 3000 });
                onClose();
                onEliminado();
            }
        } catch {
            toast.error('Error al eliminar el archivo.', { position: 'top-center', autoClose: 3000 });
        } finally {
            setCargando(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/70 flex justify-center items-center z-50" onClick={onClose}>
            <div className="bg-gray-900 border border-white/10 rounded-2xl p-6 w-full max-w-sm mx-4 shadow-2xl" onClick={e => e.stopPropagation()}>
                <div className="flex items-center justify-between mb-6">
                    <h2 className="text-white font-black text-sm uppercase tracking-widest">Eliminar archivo</h2>
                    <button onClick={onClose} className="text-white/30 hover:text-white transition-colors"><X size={16} /></button>
                </div>
                <p className="text-white/40 text-xs text-center mb-6 uppercase tracking-wider">¿Desea eliminar el archivo adjunto?</p>
                <div className="flex gap-3">
                    <button onClick={onClose}
                        className="flex-1 py-3 border border-white/10 hover:border-white/20 text-white/40 hover:text-white text-xs font-black uppercase tracking-widest rounded-xl transition-all">
                        Cancelar
                    </button>
                    <button onClick={handleEliminar} disabled={cargando}
                        className="flex-1 py-3 bg-red-600 hover:bg-red-500 text-white text-xs font-black uppercase tracking-widest rounded-xl transition-all disabled:opacity-50 flex items-center justify-center gap-2">
                        {cargando ? <Loader2 size={14} className="animate-spin" /> : <Trash2 size={14} />}
                        {cargando ? 'Eliminando...' : 'Eliminar'}
                    </button>
                </div>
            </div>
        </div>
    );
}

// ─── TABLA PRINCIPAL ────────────────────────────────────────────────────────
export default function TablaRemitos() {
    const sucursal = localStorage.getItem('sucursal');
    const admin = localStorage.getItem('admin');
    const fondo = sucursal === 'sur' ? imagenfondo : imagenFondoIntegral;

    const { getCliente } = useClienteContext();
    const data = getCliente();
    const codigo = data.codigoCliente;
    const { getEmpresa } = useEmpresaContext();
    const empresa = getEmpresa();

    const [remitos, setRemitos] = useState([]);
    const [mensajeError, setMensajeError] = useState('');
    const [loading, setLoading] = useState(false);
    const [fechaDesde, setFechaDesde] = useState('');
    const [fechaHasta, setFechaHasta] = useState('');
    const [registrosFiltrados, setRegistrosFiltrados] = useState([]);
    const [estadoImprimir, setEstadoImprimir] = useState(false);
    const [showFiltrado, setShowFiltrado] = useState(false);
    const [showScrollButtons, setShowScrollButtons] = useState(false);

    // Estados modal detalle
    const [detalleMovStock, setDetalleMovStock] = useState([]);
    const [showDetalle, setShowDetalle] = useState(false);
    const [selectedRem, setSelectedRem] = useState('');

    // Estados modales archivo
    const [modalCargar, setModalCargar] = useState(false);
    const [modalEliminar, setModalEliminar] = useState(false);
    const [selectedClave, setSelectedClave] = useState(null);
    const [idArchivo, setIdArchivo] = useState(null);

    const tableContainerRef = useRef(null);
    const COLUMNAS = admin === 'true' ? [...COLUMNAS_BASE, { label: '', title: '' }] : COLUMNAS_BASE;

    useEffect(() => {
        fetchData();
        const now = new Date();
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        const fmt = (d) => d.toISOString().split('T')[0];
        setFechaDesde(fmt(firstDay));
        setFechaHasta(fmt(lastDay));
    }, [codigo]);

    useEffect(() => {
        if (tableContainerRef.current) {
            const { scrollHeight, clientHeight } = tableContainerRef.current;
            setShowScrollButtons(scrollHeight > clientHeight);
            tableContainerRef.current.scrollTop = scrollHeight;
        }
    }, [remitos, registrosFiltrados]);

    useEffect(() => {
        if (showFiltrado) actualizarRegistrosFiltrados();
    }, [remitos]);


    const fetchData = async () => {
    if (!codigo || !sucursal) { setMensajeError('Código de cliente o sucursal no definido'); return; }
    setLoading(true);
    setMensajeError('');
    try {
        // Request 1 — primeros 100 al instante
        const response = await axiosAuth.get(`/remitos/${sucursal}/${codigo}?limit=50`);
        setRemitos(response?.data);
        setLoading(false);

        // Request 2 — resto en background
        try {
            const total = await axiosAuth.get(`/remitos/${sucursal}/${codigo}`);
            if (total?.data?.length > response?.data?.length) {
                setRemitos(total?.data);
            }
        } catch (e) {
            console.warn('No se pudieron cargar todos los registros:', e.message);
        }

    } catch (error) {
        setMensajeError(error.response?.data?.message);
        setLoading(false);
    }
};

    const actualizarRegistrosFiltrados = () => {
        const filtrados = remitos?.filter(r => {
            const fecha = new Date(r?.FechaFormateada);
            return fecha >= new Date(fechaDesde) && fecha <= new Date(fechaHasta);
        });
        setRegistrosFiltrados(filtrados?.length > 0 ? filtrados : []);
        setEstadoImprimir(filtrados?.length > 0);
        setMensajeError(filtrados?.length > 0 ? '' : 'NO EXISTEN REGISTROS EN EL RANGO DE FECHAS');
    };

    const handleFiltrarClick = () => {
        const filtrados = remitos?.filter(r => {
            const fecha = new Date(r?.FechaFormateada);
            return fecha >= new Date(fechaDesde) && fecha <= new Date(fechaHasta);
        });
        setRegistrosFiltrados(filtrados?.length > 0 ? filtrados : []);
        setShowFiltrado(true);
        setMensajeError(filtrados?.length > 0 ? '' : 'NO EXISTEN REGISTROS EN EL RANGO DE FECHAS');
        setEstadoImprimir(filtrados?.length > 0);
    };

    const handleImprimirClick = () => generarPdfRemitos(registrosFiltrados, data, empresa, fechaDesde, fechaHasta);

    const handleArchivoCargado = async () => { await fetchData(); if (showFiltrado) actualizarRegistrosFiltrados(); };
    const handleArchivoEliminado = async () => { await fetchData(); if (showFiltrado) actualizarRegistrosFiltrados(); };

    const handleAbrirArchivo = (base64Archivo) => {
        if (!base64Archivo) return;
        const isPdf = base64Archivo.includes('data:application/pdf');
        const isImg = base64Archivo.includes('data:image');
        if (!isPdf && !isImg) { alert('El archivo no es un PDF ni una imagen válida.'); return; }
        const type = isPdf ? 'application/pdf' : 'image/png';
        const bin = atob(base64Archivo.split(',')[1]);
        const arr = [];
        for (let i = 0; i < bin.length; i += 1024) {
            const slice = bin.slice(i, i + 1024);
            arr.push(new Uint8Array(Array.from(slice).map(c => c.charCodeAt(0))));
        }
        window.open(URL.createObjectURL(new Blob(arr, { type })), '_blank');
    };

    const handleAbrirArchivoDesdeAPI = async (clave) => {
        if (!clave) { toast.warn('No hay clave de archivo disponible.', { autoClose: 3000 }); return; }
        try {
            const response = await axiosAuth.get(`/archivoremito/${sucursal}/${clave}`)
            if (!response.data?.archivo) { toast.error('EL REMITO NO CONTIENE IMAGEN ADJUNTA.', { autoClose: 3000 }); return; }
            handleAbrirArchivo(response.data?.archivo);
        } catch (error) {
            toast.error(error.response?.data?.mensaje || 'Error al abrir el archivo.', { position: 'top-center', autoClose: 3000 });
        }
    };

    const registros = showFiltrado ? registrosFiltrados : remitos;

    return (
        <div className="flex flex-col h-full bg-white">

            {/* HEADER */}
            <div className="flex-shrink-0 bg-[#050f08] border-b border-gray-700">
                <div className="px-4 py-1 flex flex-col items-center gap-1">
                    <p className="text-white font-bold text-xs tracking-widest uppercase text-center">
                        Histórico de Remitos
                    </p>
                    <p className="text-gray-400 text-[10px] uppercase tracking-wider">
                        Actualizado: {new Date(empresa?.updatedAt)?.toLocaleString('es-ES', { hour12: false })}
                    </p>
                </div>
            </div>

            {/* FILTRO */}
            <div className="flex-shrink-0 bg-white border-b border-gray-200 px-3 py-2">
                <FiltroFechas
                    handleFiltrarClick={handleFiltrarClick}
                    estadoImprimir={estadoImprimir}
                    handleImprimirClick={handleImprimirClick}
                    setFechaDesde={setFechaDesde}
                    setFechaHasta={setFechaHasta}
                    fechaDesde={fechaDesde}
                    fechaHasta={fechaHasta}
                />
            </div>

            {/* TABLA */}
            <div className="overflow-auto relative flex-1" ref={tableContainerRef}
                style={{
                    backgroundImage: `url(${fondo})`,
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    // maxHeight: 'calc(100vh - 220px)'
                }}>

                {loading && (
                    <div className="absolute inset-0 bg-white/80 flex items-center justify-center z-10">
                        <div className="flex flex-col items-center gap-3">
                            <Loader2 size={28} className="text-gray-400 animate-spin" />
                            <span className="text-gray-400 text-xs uppercase tracking-widest font-bold">Cargando...</span>
                        </div>
                    </div>
                )}

                {!loading && mensajeError && (
                    <div className="m-4 flex items-center gap-3 bg-red-50 border border-red-200 rounded-xl px-4 py-3">
                        <AlertCircle size={16} className="text-red-400 flex-shrink-0" />
                        <p className="text-red-600 text-xs font-black uppercase tracking-wider">{mensajeError}</p>
                    </div>
                )}

                <table className="w-full border-collapse text-xs">
                    <thead>
                        <tr className="bg-gray-800 sticky top-0 z-10">
                            {COLUMNAS.map((col, i) => (
                                <th key={i} title={col.title}
                                    className="sticky top-0 px-2 py-1 border-r border-gray-700 text-white/80 font-bold uppercase tracking-wider whitespace-nowrap text-center last:border-r-0">
                                    {col.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {registros?.map((rem, index) => (
                            <tr key={index} className="bg-white/85 hover:bg-blue-200 transition-colors border-b border-gray-200 text-center">
                                <td className="px-2 py-1 border-r border-gray-100 whitespace-nowrap text-gray-700">{rem?.Fecha}</td>
                                <td className="px-2 py-1 border-r border-gray-100 text-gray-600">{rem?.Codadminis}</td>
                                <td className="px-2 py-1 border-r border-gray-100 whitespace-nowrap text-right text-gray-700">{rem?.Talonario}-{rem?.Nrocomprobante}</td>
                                <td className="px-2 py-1 border-r border-gray-100 text-gray-600">{rem?.Tipomov}</td>
                                <td className="px-2 py-1 border-r border-gray-100 text-gray-600">{rem?.Deposito}</td>
                                <td className="px-2 py-1 border-r border-gray-100 text-left text-gray-500 max-w-[200px] truncate cursor-pointer"
                                    title={rem?.Comentarios}>
                                    {rem?.Comentarios}
                                </td>
                                <td className={`px-2 py-1 border-r border-gray-100 whitespace-nowrap text-xs font-semibold ${estadoClass(rem)}`}>
                                    {estadoText(rem)}
                                </td>
                                <td className="px-2 py-1 border-r border-gray-100 whitespace-nowrap text-gray-600 text-xs">
                                    {propiedadLabel(rem?.Propiedad)}
                                </td>
                                <td className="px-2 py-1 border-r border-gray-100 text-green-600 font-bold">{rem?.Vtaanticipada == '1' ? '✔' : ''}</td>
                                <td className="px-2 py-1 border-r border-gray-100 text-green-600 font-bold">{rem?.Muevestock == '1' ? '✔' : ''}</td>
                                <td className="px-2 py-1 border-r border-gray-100 text-green-600 font-bold">{rem?.Genfactura == '1' ? '✔' : ''}</td>
                                <td className="px-2 py-1 border-r border-gray-100">
                                    <button onClick={() => { setSelectedRem(rem); setDetalleMovStock(rem?.Detalles); setShowDetalle(true); }}
                                        className="flex items-center justify-center mx-auto text-gray-400 hover:text-blue-600 transition-colors">
                                        <BookOpen size={15} />
                                    </button>
                                </td>
                                <td className="px-2 py-1 border-r border-gray-100">
                                    {rem?.Archivo && (
                                        <button onClick={() => handleAbrirArchivoDesdeAPI(rem?.Clave)}
                                            className="flex items-center justify-center mx-auto text-gray-400 hover:text-[#c9a84c] transition-colors">
                                            <Image size={15} />
                                        </button>
                                    )}
                                </td>
                                {admin === 'true' && (
                                    <td className="px-2 py-1">
                                        {rem?.Archivo ? (
                                            <button onClick={() => { setIdArchivo(rem?.idArchivo); setModalEliminar(true); }}
                                                className="flex items-center justify-center mx-auto text-gray-400 hover:text-red-500 transition-colors">
                                                <Trash2 size={15} />
                                            </button>
                                        ) : (
                                            <button onClick={() => { setSelectedClave(rem?.Clave); setModalCargar(true); }}
                                                className="flex items-center justify-center mx-auto text-gray-400 hover:text-green-500 transition-colors">
                                                <Plus size={15} />
                                            </button>
                                        )}
                                    </td>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* FOOTER */}
            <div className="flex-shrink-0 bg-[#050f08] px-4 py-4 md:py-0.5 lg:py-0.5 flex items-center justify-between">
                <span className="text-gray-400 text-[12px] md:text-[10px] lg:text-[10px] uppercase tracking-widest font-bold">Remitos</span>
                <span className="text-white font-black text-sm tracking-wider">
                    {registros?.length || 0} REGISTROS
                </span>
                {showScrollButtons && (
                    <div className="flex gap-2">
                        <button onClick={() => tableContainerRef.current.scrollTop = 0}
                            className="w-12 h-12  md:w-7 md:h-7 lg:w-7 lg:h-7 bg-gray-700 hover:bg-gray-600 rounded-full flex items-center justify-center text-white transition-all">
                            <ChevronUp size={14} />
                        </button>
                        <button onClick={() => tableContainerRef.current.scrollTop = tableContainerRef.current.scrollHeight}
                            className="w-12 h-12  md:w-7 md:h-7 lg:w-7 lg:h-7 bg-gray-700 hover:bg-gray-600 rounded-full flex items-center justify-center text-white transition-all">
                            <ChevronDown size={14} />
                        </button>
                    </div>
                )}
            </div>

            {/* MODALES */}
            {showDetalle && (
                <DetalleRemito
                    detalleMovStock={detalleMovStock}
                    onClose={() => { setShowDetalle(false); setDetalleMovStock(''); }}
                    remito={selectedRem}
                />
            )}
            {modalCargar && (
                <ModalCargarArchivo
                    clave={selectedClave}
                    onClose={() => { setModalCargar(false); setSelectedClave(null); }}
                    onCargado={handleArchivoCargado}
                />
            )}
            {modalEliminar && (
                <ModalEliminarArchivo
                    idArchivo={idArchivo}
                    onClose={() => { setModalEliminar(false); setIdArchivo(null); }}
                    onEliminado={handleArchivoEliminado}
                />
            )}
        </div>
    );
}